<!--票据打印页面-->
<template>
    <a-card :bordered="false" :class="{'abcdefg':true}">
      <div class="no-print" style="text-align: right;margin-bottom: 20px">
        <a-button v-print="'#printContent'" ghost type="primary">{{ $t('打印') }}</a-button>
      </div>
      <section ref="print" id="printContent" class="print-section">
        <div style="text-align: center">
          <p style="font-size: 24px;font-weight: 800">{{ $t('汤原农场自来水水司收费票据') }}</p>
        </div>
        <table border="1" id="table" width="700">
          <tr>
            <td>{{ $t('交易时间') }}</td>
            <td>{{model.updateTime?model.updateTime:model.createTime}}</td>
            <td>{{ $t('订单号') }}</td>
            <td>{{model.payOrderId}}</td>
          </tr>
          <tr>
            <td>{{ $t('用户编号') }}</td>
            <td>{{model.meterUserId}}</td>
            <td>{{ $t('表编号') }}</td>
            <td>{{model.meterId}}</td>
          </tr>
          <tr>
            <td>{{ $t('用户姓名') }}</td>
            <td>{{model.userName}}</td>
            <td>{{ $t('地址') }}</td>
            <td>{{model.userAddr}}</td>
          </tr>
          <!--
          <tr>
            <td>{{ $t('水费单价(元/m³)') }}</td>
            <td>{{model.userPriceTotal}}</td>
            <td>{{ $t('污水处理费(元/m³)') }}</td>
            <td>{{model.userPriceCharge?model.userPriceCharge: ''}}</td>
          </tr>
          -->
          <tr>
            <td>{{ $t('价格信息') }}</td>
            <td>{{model.userPriceName}} ({{model.userPriceTotal}}{{$t('元/m³')}})</td>
            <td>{{ $t('水量(m³)') }}</td>
            <td>{{model.payWaterNum}}</td>
          </tr>
          <tr>
            <td>{{ $t('交易方式') }}</td>
            <td>{{model.userAccountPayType?payType[model.userAccountPayType]: $t('未知')}}</td>
            <td>{{ $t('交易金额(元)') }}</td>
            <td>{{model.userPayAccountNum}}</td>
          </tr>
          <tr>
            <td>{{ $t('交易金额(大写)') }}</td>
            <td colspan="3">{{model.userPayAccountNum|changeToChinese}}</td>
          </tr>
          <tr>
            <td>{{ $t('操作员') }}</td>
            <td colspan="3">
              {{ $t('收费员:') }}{{model.chargeUserName?model.chargeUserName:model.updateBy?model.updateBy:model.createBy}}&nbsp;&nbsp;{{ $t('打印员:') }}{{nickname()}}&nbsp;&nbsp;{{ $t('打印时间:') }}{{moment().format('YYYY-MM-DD HH:mm:ss')}}
            </td>
          </tr>
        </table>
      </section>
    </a-card>
</template>
<script>
import { changeToChinese } from '@/utils/util'
import moment from "moment"
import { mapGetters } from 'vuex'
import {payTypeObj} from '@/utils/constants/commonConstant'
export default {
  filters: {changeToChinese},
    props: {
        'model': Object
    },
    data() {
        return {
            visible: false,
            payType: payTypeObj
        }
    },
    methods: {
        moment,
        ...mapGetters(["nickname", "avatar","userInfo"]),
    }
}
</script>
<style>
#table td{text-align: center;}
.print-section{
  color: #000;
}
</style>